import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import WikiPage from './components/WikiPage'
import { ThemeProvider, useTheme } from './components/ThemeContext'
import './index.css' // Import globally, apply to all markdown instances

// Define the custom theme you want to use
const discordTheme = {
	primaryColor: '#5865F2', // Discord's blurple (primary brand color)
	secondaryColor: '#28a745', // Green used for online status or highlights
	backgroundColor: '#1C1C1C', // Discord's dark background
	lightBackgroundColor: '#80848E', // Discord's dark background
	textColor: '#FFFFFF', // White for text
	sidebarBackgroundColor: '#313338', // Slightly darker sidebar background
	mutedTextColor: '#7289DA', // Muted grayish text (used for secondary text or labels)
	linkHoverColor: '#65AAD8', // Lighter version of the primary color for hover effects
	headerBackgroundColor: '#282B30',
	headerTextColor: '#FFFFFF'
}

const App: React.FC = () => {
	return (
		<ThemeProvider theme={discordTheme}>
			<ThemedAppWrapper>
				<WikiPage />
			</ThemedAppWrapper>
		</ThemeProvider>
	)
}

// Wrapper component to apply the theme's background color
const ThemedAppWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const theme = useTheme() // Access the theme

	return (
		<Router>
			<div
				style={{
					backgroundColor: theme.backgroundColor,
					color: theme.textColor,
					minHeight: '100vh', // Ensures background covers the full height
					padding: '0',
					margin: '0',
					display: 'flex',
					flexDirection: 'column'
				}}
			>
				{children}
			</div>
		</Router>
	)
}

export default App

